import React, { useContext, useCallback, useEffect } from 'react';
import { PopperDropdownContent } from '../../../PopperDropdownLayout';
import StandardMenu from '../../../MenuPreset/StandardMenu';
import { DropdownStateContext } from '../../../DropdownStateManager';
const defaultOffsetModifier = [
    0,
    6
];
const StandardDropdownMenu = ({ id, items, role, usePortal, placement = 'bottom-start', initiallyOpen, className, menuClassName, popperClassName, itemClassName, offsetModifier = defaultOffsetModifier, menuInnerRef, menuLabel, menuScrollable, hideCheckIcon, menuLabelClassName, withHoverEffect, withMenuPaddings, withScrollableArrows, allowFlip = true, onSelect })=>{
    const { openDropdown, closeDropdown } = useContext(DropdownStateContext);
    const onMenuSelect = useCallback((value, label)=>{
        onSelect && onSelect(value, label);
        closeDropdown();
    }, [
        onSelect,
        closeDropdown
    ]);
    useEffect(()=>{
        initiallyOpen && openDropdown();
    // adding openDropdown to this will cause it to stay open since
    // a change in isOpen will regenerate openDropdown and this will fire again
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initiallyOpen
    ]);
    return /*#__PURE__*/ React.createElement(PopperDropdownContent, {
        usePortal: usePortal,
        placement: placement,
        offsetModifier: offsetModifier,
        popperClassName: popperClassName,
        allowFlip: allowFlip
    }, /*#__PURE__*/ React.createElement(StandardMenu, {
        id: id,
        className: className,
        menuClassName: menuClassName,
        scrollable: menuScrollable,
        label: menuLabel,
        labelClassName: menuLabelClassName,
        items: items,
        itemClassName: itemClassName,
        hideCheckIcon: hideCheckIcon,
        withHoverEffect: withHoverEffect,
        withScrollableArrows: withScrollableArrows,
        withPaddings: withMenuPaddings,
        onSelect: onMenuSelect,
        role: role,
        innerRef: menuInnerRef
    }));
};
StandardDropdownMenu.displayName = 'StandardDropdownMenu';
export default StandardDropdownMenu;

//# sourceMappingURL=StandardDropdownMenu.js.map